import { useState } from 'react';

export interface PaymentRequestPassiveCheckboxesState {
  showPendingAccounts: boolean;
  showAppliedDocuments: boolean;
  showPayouts: boolean;
  showClientInfo: boolean;
  showDates: boolean;
  showAmounts: boolean;
  showObservation: boolean;
}

export interface PaymentRequestPassiveCheckboxesSetters {
  setShowPendingAccounts: (value: boolean) => void;
  setShowAppliedDocuments: (value: boolean) => void;
  setShowPayouts: (value: boolean) => void;
  setShowClientInfo: (value: boolean) => void;
  setShowDates: (value: boolean) => void;
  setShowAmounts: (value: boolean) => void;
  setShowObservation: (value: boolean) => void;
}

export const usePaymentRequestPassiveCheckboxes = (): [
  PaymentRequestPassiveCheckboxesState,
  PaymentRequestPassiveCheckboxesSetters,
] => {
  const [showPendingAccounts, setShowPendingAccounts] = useState(true);
  const [showAppliedDocuments, setShowAppliedDocuments] = useState(true);
  const [showPayouts, setShowPayouts] = useState(true);
  const [showClientInfo, setShowClientInfo] = useState(true);
  const [showDates, setShowDates] = useState(true);
  const [showAmounts, setShowAmounts] = useState(true);
  const [showObservation, setShowObservation] = useState(true);

  const state: PaymentRequestPassiveCheckboxesState = {
    showPendingAccounts,
    showAppliedDocuments,
    showPayouts,
    showClientInfo,
    showDates,
    showAmounts,
    showObservation,
  };

  const setters: PaymentRequestPassiveCheckboxesSetters = {
    setShowPendingAccounts,
    setShowAppliedDocuments,
    setShowPayouts,
    setShowClientInfo,
    setShowDates,
    setShowAmounts,
    setShowObservation,
  };

  return [state, setters];
};
